module.exports = __webpack_public_path__ + "img/farming_30.0d9b5b1b.png";